import { lazy } from 'react';

/**
 * pages.config.js - Page routing configuration
 *
 * Pages are lazy-loaded so they don't bloat the entry bundle.
 * The public landing page (/start) is imported directly in App.jsx and
 * stays in the entry chunk; everything here is split into per-page chunks.
 */

const __Layout = lazy(() => import('./Layout.jsx'));

const AboutUs = lazy(() => import('./pages/AboutUs'));
const AvailabilityOverview = lazy(() => import('./pages/AvailabilityOverview'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogManagement = lazy(() => import('./pages/BlogManagement'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Categories = lazy(() => import('./pages/Categories'));
const CommunicationTemplates = lazy(() => import('./pages/CommunicationTemplates'));
const ContractClauses = lazy(() => import('./pages/ContractClauses'));
const Customers = lazy(() => import('./pages/Customers'));
const DiscountCoupons = lazy(() => import('./pages/DiscountCoupons'));
const Equipment = lazy(() => import('./pages/Equipment'));
const FAQManagement = lazy(() => import('./pages/FAQManagement'));
const Home = lazy(() => import('./pages/Home'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const MaintenanceManagement = lazy(() => import('./pages/MaintenanceManagement'));
const ManualPayments = lazy(() => import('./pages/ManualPayments'));
const Orders = lazy(() => import('./pages/Orders'));
const PaymentHistoryManagement = lazy(() => import('./pages/PaymentHistoryManagement'));
const PopUpManagement = lazy(() => import('./pages/PopUpManagement'));
const Reservas = lazy(() => import('./pages/Reservas'));
const Reservations = lazy(() => import('./pages/Reservations'));
const SEOTools = lazy(() => import('./pages/SEOTools'));
const Settings = lazy(() => import('./pages/Settings'));
const Shop = lazy(() => import('./pages/Shop'));
const ShopAdmin = lazy(() => import('./pages/ShopAdmin'));
const ShopCheckout = lazy(() => import('./pages/ShopCheckout'));
const ShopOrderSuccess = lazy(() => import('./pages/ShopOrderSuccess'));
const ShopOrders = lazy(() => import('./pages/ShopOrders'));
const StockManagement = lazy(() => import('./pages/StockManagement'));
const Stores = lazy(() => import('./pages/Stores'));
const UserSettings = lazy(() => import('./pages/UserSettings'));
const Users = lazy(() => import('./pages/Users'));
const Welcome = lazy(() => import('./pages/Welcome'));


export const PAGES = {
    "AboutUs": AboutUs,
    "AvailabilityOverview": AvailabilityOverview,
    "Blog": Blog,
    "BlogManagement": BlogManagement,
    "BlogPost": BlogPost,
    "Categories": Categories,
    "CommunicationTemplates": CommunicationTemplates,
    "ContractClauses": ContractClauses,
    "Customers": Customers,
    "DiscountCoupons": DiscountCoupons,
    "Equipment": Equipment,
    "FAQManagement": FAQManagement,
    "Home": Home,
    "LandingPage": LandingPage,
    "MaintenanceManagement": MaintenanceManagement,
    "ManualPayments": ManualPayments,
    "Orders": Orders,
    "PaymentHistoryManagement": PaymentHistoryManagement,
    "PopUpManagement": PopUpManagement,
    "Reservas": Reservas,
    "Reservations": Reservations,
    "SEOTools": SEOTools,
    "Settings": Settings,
    "Shop": Shop,
    "ShopAdmin": ShopAdmin,
    "ShopCheckout": ShopCheckout,
    "ShopOrderSuccess": ShopOrderSuccess,
    "ShopOrders": ShopOrders,
    "StockManagement": StockManagement,
    "Stores": Stores,
    "UserSettings": UserSettings,
    "Users": Users,
    "Welcome": Welcome,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};